module.exports = __webpack_public_path__ + "img/exchange.ce27be41.svg";